import { render, staticRenderFns } from "./PanelList.vue?vue&type=template&id=346bc53a"
import script from "./PanelList.vue?vue&type=script&lang=js"
export * from "./PanelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports